import {
    collection,
    addDoc,
    getDocs,
    deleteDoc,
    serverTimestamp,
    query,
    orderBy,
    doc,
    updateDoc
} from "firebase/firestore";
import { db } from "../../firebase";

/* ======================
   CUSTOMERS
====================== */
export async function getCustomers() {
    const q = query(
        collection(db, "customers"),
        orderBy("createdAt", "desc")
    );
    const snap = await getDocs(q);
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function addCustomer(data) {
    await addDoc(collection(db, "customers"), {
        ...data,
        createdAt: serverTimestamp()
    });
}

export async function deleteCustomer(id) {
    await deleteDoc(doc(db, "customers", id));
}

export async function updateCustomer(id, data) {
    if (!id) return;

    await updateDoc(doc(db, "customers", id), {
        ...data,
        updatedAt: serverTimestamp()
    });
}

/* ======================
   ITEMS (CATALOGUE)
====================== */
export async function getItems() {
    const snap = await getDocs(collection(db, "items"));
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function addItem(item) {
    await addDoc(collection(db, "items"), {
        ...item,
        createdAt: serverTimestamp()
    });
}

export async function updateItem(id, item) {
    if (!id) return;

    await updateDoc(doc(db, "items", id), {
        ...item,
        updatedAt: serverTimestamp()
    });
}

export async function deleteItem(id) {
    if (!id) return;

    await deleteDoc(doc(db, "items", id));
}

/* ======================
   INVOICES
====================== */
export async function getInvoices() {
    const q = query(
        collection(db, "invoices"),
        orderBy("createdAt", "desc")
    );
    const snap = await getDocs(q);
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function addInvoice(payload) {
    await addDoc(collection(db, "invoices"), {
        ...payload,
        createdAt: serverTimestamp()
    });
}


// ✅ TAMBAH INI
export async function deleteInvoice(id) {
    if (!id) return;
    await deleteDoc(doc(db, "invoices", id));
}

export const updateInvoice = async (invoiceId, payload) => {
    const invoiceRef = doc(db, "invoices", invoiceId);

    await updateDoc(invoiceRef, {
        ...payload,
        updatedAt: serverTimestamp()
    });
};